import React from 'react';
import SetProject from './SetProject';

const Jira = ({ onClose, vulnsSelected, vulnId, isVulnDetailOpen, entity }) => <SetProject onClose={ onClose } vulnsSelected={ vulnsSelected } vulnId={ vulnId } isVulnDetailOpen={ isVulnDetailOpen } entity={ entity } />;

export default Jira;
